import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCredits(c: number): string {
  return Number.isInteger(c) ? String(c) : c.toFixed(1);
}